import { useMemo } from 'react';
import { useTenant } from '@packlink/tenant-provider';

import Tracker from './amplitude';
import { AmplitudeEvents, AmplitudeProperties } from './events';
import { Amplitude3DsecureProperties, ProviderName } from '@packlink/metrics';

type PayloadKey = AmplitudeEvents;
type PayloadEvent = Record<PayloadKey & AmplitudeProperties & Amplitude3DsecureProperties, unknown>;
export type SendAmplitude = (eventName: AmplitudeEvents | string, payloadEvent?: PayloadEvent) => void;

const trackEvent =
    (tenant: string, platformCountry: string, platform: string, eventPayload?: PayloadEvent): SendAmplitude =>
    (eventName: AmplitudeEvents | string, payloadEvent: PayloadEvent = eventPayload || {}): void => {
        const payload: PayloadEvent = {
            ...payloadEvent,
            [AmplitudeProperties.PLATFORM_COUNTRY]: platformCountry,
            [AmplitudeProperties.PLATFORM]: platform,
            [AmplitudeProperties.TENANT]: tenant,
        };
        Tracker.track({
            eventName,
            providerName: ProviderName.AMPLITUDE,
            payload,
        });
    };

export function useAmplitude(): SendAmplitude {
    const tenant = useTenant();
    const sendEvent = useMemo(
        (payload?: PayloadEvent) =>
            tenant?.name && trackEvent(tenant.name, tenant.mapToPlatformCountry(), tenant.mapToPlatform(), payload),
        [tenant],
    );
    return sendEvent;
}
